'use strict'; // eslint-disable-line

/**
 * @type {jQuery|exports|module.exports|Function}
 */

var jQuery = require('jquery');

module.exports = Item;

/**
 * Dropdown item
 * @param {String} title
 * @param {String} value
 * @param {Function} onClickHandler
 * @constructor
 */
function Item(title, value, onClickHandler) {
    this.$obj = jQuery('<li></li>');
    this.$link = jQuery('<a href="#" data-test-selector="block-dropDownItem"></a>');
    this.$title = jQuery('<span></span>');
    this.$icon = jQuery('<svg class="ui-icon ui-icon_sizeMedium ui-dropdownList__icon">' + '<use xlink:href="img/icons.svg#icon-tick"></use>' + '</svg>');

    this.title = title;
    this.value = value;
    this.onClickHandler = onClickHandler;

    this.init();
}

Item.prototype.CLASS_ITEM = 'ui-dropdownList__item';
Item.prototype.CLASS_LINK = 'ui-dropdownList__link';
Item.prototype.CLASS_TITLE = 'ui-dropdownList__title';
Item.prototype.CLASS_ICON_SELECTED = 'ui-dropdownList__icon_selected';

/**
 * Initialize
 * @returns {Item}
 */
Item.prototype.init = function () {
    this.$obj.addClass(this.CLASS_ITEM);
    this.$link.addClass(this.CLASS_LINK);
    this.$title.addClass(this.CLASS_TITLE);

    this.setTitle(this.title).setValue(this.value).bindEvents().render();

    return this;
};

/**
 * Bind Events
 * @returns {Item}
 */
Item.prototype.bindEvents = function () {
    this.$obj.on('click.item.rp.selectDropdown', this.onClickHandler);

    return this;
};

/**
 * Compose object
 * @returns {jQuery}
 */
Item.prototype.render = function () {
    return this.$obj.append(this.$link.append(this.$title).append(this.$icon));
};

/**
 * @param {String} title
 * @returns {Item}
 */
Item.prototype.setTitle = function (title) {
    this.$title.text(title);

    return this;
};

/**
 * @param {String} value
 * @returns {Item}
 */
Item.prototype.setValue = function (value) {
    this.$link.data('data-value', value);

    return this;
};

/**
 * Mark item as selected
 * @returns {Item}
 */
Item.prototype.select = function () {
    this.$icon.attr('class', jQuery.proxy(function (index, classNames) {
        return classNames + ' ' + this.CLASS_ICON_SELECTED;
    }, this));

    return this;
};

/**
 * Remove selection
 * @returns {Item}
 */
Item.prototype.unselect = function () {
    this.$icon.attr('class', jQuery.proxy(function (index, classNames) {
        return classNames.replace(this.CLASS_ICON_SELECTED, '');
    }, this));

    return this;
};

/**
 * Check if item is selected
 * @returns {boolean}
 */
Item.prototype.isSelected = function () {
    return this.$icon.attr('class').split(' ').indexOf(Item.prototype.CLASS_ICON_SELECTED) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-select/lib/item.js
// module id = 1784
// module chunks = 1